<template>
  <div class="">
    <el-select
      v-model="categoriesModel"
      @change="categoriesChanged"
      autocomplete="new-password"
      :placeholder="placeholder ? placeholder : $t('COMMON.CATEGORIES')"
      :filterable="filterable"
      :multiple="true"
      :disabled="disabled"
      remote
      :remote-method="getCategories"
      :loading="loading"
      collapse-tags
    >
      <el-option
        v-for="(category, key) in categoriesList"
        :key="key"
        :value="category.id"
        :label="`${category.name}`"
      >
      </el-option>
    </el-select>
  </div>
</template>

<script>
import { Option, Select } from "element-ui";
import { difference } from "lodash";

export default {
  name: "categories-selector",

  components: {
    [Select.name]: Select,
    [Option.name]: Option,
  },

  props: {
    disabled: {
      type: Boolean,
      default: false,
      description: "Disable the input",
    },
    filterable: {
      type: Boolean,
      default: true,
      description: "Can filter",
    },
    multiple: {
      type: Boolean,
      default: false,
      description: "Can filter",
    },
    categories: {
      type: Array,
      default: () => [],
      description: "Warehouse id",
    },
    filterIdsNotIn: {
      type: Array,
      default: () => [],
      description: "Warehouse not in list id",
    },
    filterOrganization: {
      type: String,
      default: null,
      description: "Organization id",
    },
    placeholder: {
      type: String,
      default: null,
      description: "Placeholder",
    },
    filterActive: {
      type: Boolean,
      default: true,
      description: "Only show active categories",
    },
  },

  data() {
    return {
      categoriesModel: [...this.categories].map((item) => item.id),
      categoriesList: [],
      loading: false,
    };
  },

  setup() {},

  created() {
    this.getCategories(null, this.categories);
  },

  methods: {
    async getCategories(query = null, ids = null) {
      try {
        this.loading = true;
        let params = {
          sort: "-created_at",
          filter: {
            ...(query ? { search: encodeURIComponent(query) } : {}),
            ...(ids?.length ? { ids: ids.map((item) => item.id) } : {}),
          },
          page: {
            number: 1,
            size: 999,
          },
        };

        if (this.filterOrganization) {
          params = {
            ...params,
            filter: {
              ...params.filter,
              organization: this.filterOrganization,
            },
          };
        }

        if (this.filterActive) {
          params = {
            ...params,
            filter: {
              ...params.filter,
              active: 1,
            },
          };
        }

        if (this.filterIdsNotIn.length > 0) {
          params = {
            ...params,
            filter: {
              ...params.filter,
              idsNotIn: this.filterIdsNotIn,
            },
          };
        }
        await this.$store.dispatch("categories/list", params);
        const categoriesArr = await this.$store.getters["categories/list"];
        this.categoriesList = {};
        categoriesArr.forEach((category) => {
          this.categoriesList[category.id] = category;
        });
        this.loading = false;
      } catch (error) {
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
        this.loading = false;
      }
    },

    categoriesChanged(categories) {
      this.$emit(
        "categoriesChanged",
        [...categories].map((item) => ({ type: "categories", id: item }))
      );
    },
  },

  watch: {
    categories(categories) {
      if (categories?.length) {
        const categoriesData = categories.map((item) => item.id);
        if (difference(categoriesData, this.locationsModel).length !== 0) {
          this.categoriesModel = categoriesData;
        }
      } else {
        this.categoriesModel = [];
      }
    },
    filterOrganization(filterOrganization) {
      this.getCategories();
    },
    filterIdsNotIn(filterIdsNotIn) {
      this.getCategories();
    },
  },
};
</script>
